import { render } from "./prospectlist.vue?vue&type=template&id=dbb5a02e"
import script from "./prospectlist.vue?vue&type=script&lang=js"
export * from "./prospectlist.vue?vue&type=script&lang=js"

import "./prospectlist.vue?vue&type=style&index=0&id=dbb5a02e&lang=css"
import "./prospectlist.vue?vue&type=style&index=1&id=dbb5a02e&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__